import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Roles, UserAddDto } from 'app/modules/user/user.model';
import { environment } from 'environment/environment';
import { Observable, Subject, catchError, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CommonDropdownService {

  private apiUrl: string;
  private subjectName = new Subject<any>();
  private subject = new Subject<any>();
  id: number;
  private switchTabSubject = new Subject<{ index: number, data: any }>();

  constructor(private httpClient: HttpClient, public activatedRoute: ActivatedRoute) {
    this.apiUrl = environment.baseUrl;
  }


  getRoleId(transportActivityId: number): Observable<Roles[]> {
    const url = this.apiUrl + "User/GetRoleNameList" + transportActivityId;
    return this.httpClient.get<Roles[]>(url);
  }

  getUserRoleRightsMenu(): Observable<any> {

  
    const body = {
      UserId:'55'
    };
    
    return this.httpClient.post<any>(this.apiUrl + 'UserMenuRights/GetUserMenu', body).pipe(catchError(this.handleError));
    
  }

  handleError(error: HttpErrorResponse) {
    return throwError(error);
  }

  switchTab$ = this.switchTabSubject.asObservable();
  switchTab(index: number, data: any) {
    this.switchTabSubject.next({ index, data });
  }
}
